export const GET_ALL_HIRING = "GET_ALL_HIRING";
export const GET_ALL_HIRING_SUCCESS = "GET_ALL_HIRING_SUCCESS";
export const GET_ALL_HIRING_FAILURE = "GET_ALL_HIRING_FAILURE";

export const GET_SINGLE_HIRING = "GET_SINGLE_HIRING";
export const GET_SINGLE_HIRING_SUCCESS = "GET_SINGLE_HIRING_SUCCESS";
export const GET_SINGLE_HIRING_FAILURE = "GET_SINGLE_HIRING_FAILURE";

export const DELETE_SINGLE_HIRING = "DELETE_SINGLE_HIRING";
export const DELETE_SINGLE_HIRING_SUCCESS = "DELETE_SINGLE_HIRING_SUCCESS";
export const DELETE_SINGLE_HIRING_FAILURE = "DELETE_SINGLE_HIRING_FAILURE";
